export function isDevopsPreviewHost(hostname: string): boolean {
  return hostname.endsWith('.devops-760.workers.dev');
}
